export default {
  SET_ROLES: 'SET_ROLES',
  SET_ROLES_IS_LOADING: 'SET_ROLES_IS_LOADING'
}